import type { Team } from '@shared/types/entities';

/** GV-02: distinguish the sporting captain (TeamPlayer J1) from the admin payer. */
export function getTeamSportingCaptain(team: Team) {
  return team.registeredByOrganizer ? team.players?.find(player => player.playerOrder === 1) : team.captain;
}

/** An organizer's personal payer email must not be displayed as a player's email. */
export function getTeamSportingCaptainEmail(team: Team): string | null {
  return team.registeredByOrganizer ? null : (team.captain?.email ?? null);
}
